import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PublicRoute, PrivateRoute } from "../components/PublicRoute/PublicRoute";
import { AllVersions } from "./AllVersions";
import { App } from "./App";
import { Companies } from "./Companies";
import { Login } from "./Login";
import { ProjectDetail } from "./ProjectDetail";
import { Projects } from "./Projects";
import { ResetPassword } from "./ResetPassword";
import { ResetPasswordRequest } from "./ResetPasswordRequest";
import { Sheet } from "./Sheet";
import { Documents } from "./Documents";
import { DigitalizationDocuments } from "./DigitalizationDocuments";
import { CreateTemplate } from "./CreateTemplate";
import { UpdateTemplate } from "./UpdateTemplate";
import { DocumentsDetail } from "./DocumentsDetail";
import { KeywordsManager } from "./KeywordsManager";
import { EditKeywords } from "./EditKeywords";
import { UserManagement } from "./UserManagement";
import { UserDetail } from "./UserDetail";
import { CreateProject } from "./CreateProject";
import { UpdateProject } from "./UpdateProject";
import { UsersByProject } from "./UsersByProject";
import ApplicationHome from "./ApplicationHome";
import ApplicationProject from "./ApplicationProject";
import ApplicationUsersInfo from "./ApplicationUsersInfo";
import { ApplicationDocumentDetail } from "./ApplicationDocumentDetail";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route
            index
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="reset-password-request"
            element={
              <PublicRoute>
                <ResetPasswordRequest />
              </PublicRoute>
            }
          />
          <Route
            path="reset-password"
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          />
          <Route path="projects">
            <Route index element={
              <PrivateRoute>
                <Projects />
              </PrivateRoute>
            } />
            <Route path="create-project" element={
              <PrivateRoute>
                <CreateProject />
              </PrivateRoute>
            } />
            <Route path="update-project/:projectId" element={
              <PrivateRoute>
                <UpdateProject />
              </PrivateRoute>
            } />
            <Route path="users/:projectId" element={
              <PrivateRoute>
                <UsersByProject />
              </PrivateRoute>
            } />
            <Route path=":id">
              <Route index element={
                <PrivateRoute>
                  <ProjectDetail />
                </PrivateRoute>
              } />
              <Route path="sheet/:sheetId" element={
                <PrivateRoute>
                  <Sheet />
                </PrivateRoute>
              } />
              <Route path="sheet-versions/:sheetId" element={
                <PrivateRoute>
                  <AllVersions />
                </PrivateRoute>
              } />
            </Route>
          </Route>
          <Route path="companies" element={
            <PrivateRoute>
              <Companies />
            </PrivateRoute>
          } />
          <Route path="documents/:id">
            <Route index element={
              <PrivateRoute>
                <Documents />
              </PrivateRoute>
            } />
            <Route path="detail/:docId" element={
              <PrivateRoute>
                <DocumentsDetail />
              </PrivateRoute>
            } />
          </Route>
          <Route path="digitalization-documents">
            <Route index element={
              <PrivateRoute>
                <DigitalizationDocuments />
              </PrivateRoute>
            } />
            <Route path="create-template" element={
              <PrivateRoute>
                <CreateTemplate />
              </PrivateRoute>
            } />
            <Route path="update-template/:id">
              <Route index element={
                <PrivateRoute>
                  <UpdateTemplate />
                </PrivateRoute>
              } />
              <Route path="keywords-manager">
                <Route index element={
                  <PrivateRoute>
                    <KeywordsManager />
                  </PrivateRoute>
                } />
                <Route path="edit-keywords/:keyId" element={
                  <PrivateRoute>
                    <EditKeywords />
                  </PrivateRoute>
                } />
              </Route>
            </Route>
          </Route>
          <Route path="user-management">
            <Route index element={
              <PrivateRoute>
                <UserManagement />
              </PrivateRoute>
            } />
            <Route path=":id" element={
              <PrivateRoute>
                <UserDetail />
              </PrivateRoute>
            } />
          </Route>
          <Route path="application">
            <Route
              index
              element={
                <PrivateRoute>
                  <ApplicationHome />
                </PrivateRoute>
              }
            />
            <Route path="user-info/:userId">
              <Route index element={
                <PrivateRoute>
                  <ApplicationUsersInfo />
                </PrivateRoute>
              } />
              <Route
                path="document-detail/:docId"
                element={
                  <PrivateRoute>
                    <ApplicationDocumentDetail />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route 
              path="project/:id"
              element={
                <PrivateRoute>
                  <ApplicationProject />
                </PrivateRoute>
              } 
            />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
